import { render, staticRenderFns } from "./TitleBar.vue?vue&type=template&id=1117f7c3&"
import script from "./TitleBar.vue?vue&type=script&lang=ts&"
export * from "./TitleBar.vue?vue&type=script&lang=ts&"
import style0 from "./TitleBar.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports